import tools from '../tools/tools.js';
export default function(){
	const html = document.querySelector('html');
	const isRtl = !!document.querySelector('html[dir=rtl]');
	const me = this;
	const pane = document.querySelector('.airtheme-ext-menu-pane');
	const simple = document.querySelector('.airtheme-menu-simple');
	const burgButton = document.querySelector('.airtheme-burger');

	this.state = 1;
	this.scrollY = 0;
	this.setState = function(state){
		if(state === 1 && this.state !== 1){
			this.state = 1;
			html.classList.remove('airtheme-state2');
			html.classList.add('airtheme-state1');
		}else if(state === 2 && this.state !== 2){
			this.state = 2;
			html.classList.remove('airtheme-state1');
			html.classList.add('airtheme-state2');
		}
	}
	const isEmptyA = function(el){
		const href = el.getAttribute('href')
		return (href === '#' || href === '' || !href);
	}
	const activate = function(a){
		let el;
		if(a.classList.contains('airtheme-section-link')){
			el = a.parentElement.parentElement
		}else if(a.classList.contains('airtheme-grid-item-link')){
			el = a.parentElement
		}else{
			el = a
		}
		el.classList.add('airtheme-active');
	}
	const setActiveLinks = function(){
		document.querySelectorAll('.airtheme-active').forEach(function(el){
			el.classList.remove('airtheme-active');
		});
		const noHashLocation = document.location.href.split('#')[0]
		const isCurrent = (el)=>{
			return !isEmptyA(el) && (
				el.href === document.location.href ||
				(!el.hash && document.location.hash && el.href === noHashLocation)
			)
		}
		document.querySelectorAll('.airtheme-menu-simple li>a, .airtheme-menu li>a').forEach(function(el){
			if(isCurrent(el)){
				tools.parents(el, 'li').forEach(function(par){
					activate(par.querySelector(':scope>a'));
				});
			}
		});
		document.querySelectorAll('.wp-site-blocks a, #airtheme-primary a, #airtheme-footer a').forEach(function(el){
			if(isCurrent(el)){
				activate(el);
			}
		});
	}
	setActiveLinks();

	//Begin For Greenshift Slider
	if(!document.location.hash){
		const firstGSHashed = document.querySelector('.swiper-slide[data-hash]')
		if(firstGSHashed && firstGSHashed.dataset.hash){
			document.querySelectorAll("a[href='#"+firstGSHashed.dataset.hash+"']").forEach(function(el){
				activate(el)
			});
		}
	}
	//End For Greenshift Slider

	if(pane){
		const nav = pane.querySelector('.airtheme-nav');
		const menu = nav ? nav.querySelector('.airtheme-menu') : false;
		const allLi = menu ? menu.querySelectorAll('li') : [];
		const allLiA = menu ? menu.querySelectorAll('li a') : [];
		let impact = false;
		let impactParent = false;
		const noImpact = function(){
			if(pane && impact){
				pane.classList.remove('airtheme-impacted');
				impact.classList.remove('airtheme-impact');
				impact = false;
				if(impactParent){
					impactParent.classList.remove('airtheme-impact-parent');
					impactParent = false;
				}
			}
		}
		const impactUl = function(ul){
			if(pane && !ul.classList.contains('airtheme-impact')){
				if(ul.classList.contains('sub-menu')){
					pane.classList.add('airtheme-impacted');
					if(impact){
						impact.classList.remove('airtheme-impact');
					}
					impact = ul;
					impact.classList.add('airtheme-impact');
					if(impactParent){
						impactParent.classList.remove('airtheme-impact-parent');
					}
					impactParent = ul.parentNode.parentNode;
					impactParent.classList.add('airtheme-impact-parent');
				}else{
					noImpact();
				}
			}
		}
		const burgClick = function(){
			setTimeout(function(){
				if(burgDoClose){
					burgDoClose = false;
					noImpact();
					if(allLi.length > 0){
						allLi.forEach(function(el){el.classList.remove('airtheme-item-open');});
					}
				}
			}, 1000);
			if(document.body.classList.contains('airtheme-primary-menu-open')){
				burgDoClose = true;
				document.body.classList.remove('airtheme-primary-menu-open');
				document.body.classList.remove('airtheme-primary-menu-opened');
			}else{
				burgDoClose = false;
				document.body.classList.add('airtheme-primary-menu-open');
				setTimeout(function(){
					if(document.body.classList.contains('airtheme-primary-menu-open')){
						document.body.classList.add('airtheme-primary-menu-opened');
					}
				}, 1000)
			}
		}
		const close = function(){
			if(document.body.classList.contains('airtheme-primary-menu-open')){
				burgClick();
			}
		}
		const closeIfOnlyHashLink = (a)=>{
			if(a.href && window.location.href.split('#')[0] === a.href.split('#')[0]){
				close()
			}
		}
		const navigate = (a)=>{
			window.location.href = a.href;
			setActiveLinks();
		}
		document.querySelectorAll('.airtheme-logo a').forEach( function(el){ el.addEventListener('click', function(){
			close();
		}, tools.passiveListener) } );;
		window.addEventListener("hashchange", setActiveLinks, false);
		let burgDoClose = false;
		if(burgButton){
			burgButton.addEventListener('click', burgClick, tools.passiveListener);
		}
		if(allLi.length > 0){
			allLi.forEach(function(li){
				const layerLi = Array.prototype.filter.call(li.parentNode.children, function(ch){return ch.matches('li')});
				const sub = li.querySelector(':scope>ul');
				const a = li.querySelector(':scope>a');
				const closeLayer = function(){
					layerLi.forEach(function(itemLi){
						itemLi.classList.remove('airtheme-item-open');
						itemLi.querySelectorAll('li').forEach(function(subli){
							subli.classList.remove('airtheme-item-open');
						})
					});
				}
				const openLi = function(){
					const topMargin = nav.getBoundingClientRect().top;
					closeLayer();
					li.classList.add('airtheme-item-open');
					if(sub){
						impactUl(sub);
						const rect = li.getBoundingClientRect();
						if(!isRtl){
							if((document.documentElement.clientWidth - rect.right) < sub.offsetWidth && rect.left > sub.offsetWidth){
								sub.style.right = '100%';
								sub.style.left = 'auto';
							}else{
								sub.style.right = 'auto';
								sub.style.left = '100%';
							}
						}else{
							if((document.documentElement.clientWidth - rect.left) < sub.offsetWidth && (document.documentElement.clientWidth - rect.right) > sub.offsetWidth){
								sub.style.right = 'auto';
								sub.style.left = '100%';
							}else{
								sub.style.right = '100%';
								sub.style.left = 'auto';
							}
						}
						if((document.documentElement.clientHeight - rect.top) < (sub.offsetHeight + topMargin)){
							if(rect.bottom > (sub.offsetHeight + topMargin)){
								sub.style.top = 'auto';
								sub.style.bottom = '0px';
							}else{
								sub.style.top = 'auto';
								sub.style.bottom = (rect.bottom - sub.offsetHeight - topMargin) + 'px';
							}
						}else{
							sub.style.top = '0px';
							sub.style.bottom = 'auto';
						}
					}else{
						const currentUl = li.parentNode;
						if(!currentUl.classList.contains('airtheme-impact')){
							impactUl(currentUl);
						}
					}
				}
				if(sub){
					a.addEventListener('click', function(e){
						e.preventDefault();
					});
					a.addEventListener('pointerdown', function(e){
						if(!li.classList.contains('airtheme-item-open')){
							openLi();
						}else{
							const href = a.getAttribute('href')
							if(isEmptyA(a)){
								impactUl(li.parentNode);
								closeLayer();
								hover = true;
							}else{
								closeIfOnlyHashLink(a)
								navigate(a);
							}
						}
					}, tools.passiveListener);
				}else{
					a.addEventListener('click', function(e){
						closeIfOnlyHashLink(a)
					}, tools.passiveListener);
				}

				let hover = false;
				a.addEventListener('mouseover', function(e){
					if(!hover) {
						if(sub){
							openLi();
						}else{
							impactUl(li.parentNode);
							closeLayer();
						}
					}
					hover = true;
				}, tools.passiveListener);
				a.addEventListener('mouseleave', function(e){
					hover = false;
				}, tools.passiveListener);
			});
			if(pane){
				pane.addEventListener('click', function(e){
					const isLink = function(){
						let res = false;
						allLiA.forEach(function(a){
							if( a === e.target || a.contains(e.target) ){
								res = true;
							}
						});
						return res;
					}
					if( !isLink() ){
						noImpact();
						allLi.forEach(function(li){
							li.classList.remove('airtheme-item-open');
						});
					}
				}, tools.passiveListener);
			}
		}
	};
	if(simple){
		let openCount = 0;
		const allLi = simple.querySelectorAll('li');
		allLi.forEach(function(li){
			const sub = li.querySelector(':scope>ul');
			const a = li.querySelector(':scope>a');
			if(sub){
				let opened = false;
				const outHandler = function(e){
					if(opened && !li.contains(e.target)){
						close();
					}
				}
				const open = function(){
					openCount++;
					if(openCount === 1){
						html.classList.add('airtheme-simple-menu-opened');
					}
					li.classList.add('airtheme-item-open');
					opened = true;
					document.addEventListener('pointerdown', outHandler, tools.passiveListener);
				}
				const close = function(){
					openCount--;
					if(openCount === 0){
						html.classList.remove('airtheme-simple-menu-opened');
					}
					li.classList.remove('airtheme-item-open');
					opened = false;
					document.removeEventListener('pointerdown', outHandler);
				}
				a.addEventListener('pointerdown', function(e){
					if(opened){
						close();
						if(!isEmptyA(a)){
							navigate(a);
						}
					}else{
						open();
					}
				}, tools.passiveListener);
				a.addEventListener('click', function(e){
					e.preventDefault();
				});
				const mOver = function(e){
					if(!opened){
						open();
					}
				}
				a.addEventListener('mouseover', mOver, tools.passiveListener);
				a.addEventListener('focus', mOver);
				const mLeave = function(e){
					if(opened){
						close();
					}
				}
				li.addEventListener('mouseleave', mLeave, tools.passiveListener);
			}
			
		});
	}
	const scroll = ()=>{
		if(me.scrollY !== window.scrollY){
			me.scrollY = window.scrollY;
			if(me.scrollY > 0){
				me.setState(2);
			}else{
				me.setState(1);
			}
		}
	}
	document.addEventListener('scroll', scroll, tools.passiveListener);
	scroll()
}
